import { render, staticRenderFns } from "./PricingBot.vue?vue&type=template&id=74d38684&"
import script from "./PricingBot.vue?vue&type=script&lang=js&"
export * from "./PricingBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports